import { defineMessages } from 'react-intl';

export const sizeQuizMessages = defineMessages({
  adviceFromABraFitterHeader: {
    id: 'size-quiz.advice-from-a-bra-fitter',
    defaultMessage: 'Advice from a bra fitter',
  },
  changeBrand: {
    id: 'size-quiz.change-brand',
    defaultMessage: 'Change Brand',
  },
  chooseBackSize: {
    id: 'size-quiz.choose-back-size',
    defaultMessage: 'First choose your back size',
  },
  chooseCupSize: {
    id: 'size-quiz.choose-cup-size',
    defaultMessage: 'Now choose your cup size',
  },
  example: {
    id: 'size-quiz.example',
    defaultMessage: 'Get advice from a fitter',
  },
  finalpara1: {
    id: 'size-quiz.final-p1',
    defaultMessage:
      'Based on your answers, we recommend the best bra size for you to try is:',
  },
  finalpara2: {
    id: 'size-quiz.final-p2',
    defaultMessage:
      'Choose from styles that have over 30,000 5* reviews and more choice and colour for D cups and up than you’ll find anywhere else.​',
  },
  finalpara3: {
    id: 'size-quiz.final-p3',
    defaultMessage:
      'Not quite the size you were expecting? Don’t worry, this happens in our fitting rooms all the time. Our friendly fitters are on hand to advise you of the styles and shapes you may like to try, give us a call on ​',
  },
  finalpara3or: {
    id: 'size-quiz.final-p3-or',
    defaultMessage: ' or have a virtual fitting with us.​',
  },
  getStarted: {
    id: 'size-quiz.get-started',
    defaultMessage: "Let's Get Started",
  },
  gotItbutton: {
    id: 'size-quiz.got-it-button',
    defaultMessage: 'Got It',
  },
  label: {
    id: 'size-quiz.label',
    defaultMessage: 'Unsure of your size? Use our bra fit finder!',
  },
  liveChat: {
    id: 'size-quiz.live-chat',
    defaultMessage: 'Live Chat.',
  },
  noSizeh2: {
    id: 'size-quiz.no-size-h2',
    defaultMessage: 'We’re Sorry!',
  },
  noSizepara1: {
    id: 'size-quiz.no-size-p1',
    defaultMessage:
      'Based on your answers, we couldn’t work out the best bra size for you this time…',
  },
  noSizepara2: {
    id: 'size-quiz.no-size-p2',
    defaultMessage:
      'We’re confident that we can help you find a bra that’ll fit and support you well, so you can feel uplifted in every way! Please get in touch with our experienced and friendly fitters via the links below.',
  },
  phone: {
    id: 'size-quiz.phone',
    defaultMessage: '01926 459 859',
  },
  pressingpara1: {
    id: 'size-quiz.pressing-p1',
    defaultMessage:
      'If your underwire looks like this, it’s sitting against your breast tissue (which can hurt!) – it should sit under your armpit, fully encasing your boob',
  },
  returnToBackResult: {
    id: 'size-quiz.return-to-back-result',
    defaultMessage: 'Return to Back result',
  },
  restartBackSize: {
    id: 'size-quiz.restart-back-size',
    defaultMessage: 'Restart Back Size Questions',
  },
  restartCupSize: {
    id: 'size-quiz.restart-cup-size',
    defaultMessage: 'Restart Cup Size Questions',
  },
  restartQuiz: {
    id: 'size-quiz.restart-quiz',
    defaultMessage: 'Restart Quiz',
  },
  ridesUppara1: {
    id: 'size-quiz.rides-up-p1',
    defaultMessage:
      'If your backband looks like this, it’s riding up. Your back band should be firm (but comfortable), and should sit horizontally aroundyour body without riding up or digging in.',
  },
  shopMySize: {
    id: 'size-quiz.shop-my-size',
    defaultMessage: 'Shop My Size',
  },
  sitFlatpara1: {
    id: 'size-quiz.sit-flat-p1',
    defaultMessage:
      'If the wires look like this, they’re sitting on your boobs rather than your breastbone. The wires should sit flat between your boobs',
  },
  stage1h2: {
    id: 'size-quiz.stage-1-h2',
    defaultMessage:
      'Join over 2 million customers we’ve supported to find their most comfortable fit',
  },
  stage1para1: {
    id: 'size-quiz.stage-1-p1',
    defaultMessage:
      'Our fitters are here to support you to find a fit that feels good. If you’re unsure of your bra size or what styles work for you give us a call on ',
  },
  stage1para1or: {
    id: 'size-quiz.stage-1-p1-or',
    defaultMessage: ', speak with us via video call or ',
  },
  stage1para2: {
    id: 'size-quiz.stage-1-p2',
    defaultMessage:
      'If you’d prefer to take our quiz, then you’re in the right place!​',
  },
  stage1li1: {
    id: 'size-quiz.stage-1-li1',
    defaultMessage:
      'Pop on your favourite, best fitting everyday bra to get the most accurate results',
  },
  stage1li2: {
    id: 'size-quiz.stage-1-li2',
    defaultMessage: 'Answer questions about how this bra fits you',
  },
  stage1li3: {
    id: 'size-quiz.stage-1-li3',
    defaultMessage:
      'Get your results and enjoy shopping for your best fitting bra!',
  },
  stage1h5: {
    id: 'size-quiz.stage-1-h5',
    defaultMessage: 'What brand is the bra that you are wearing?',
  },
  stage2h5: {
    id: 'size-quiz.stage-2-h5',
    defaultMessage: 'What size is it?',
  },
  stage2h5_us: {
    id: 'size-quiz.stage-2-h5-us',
    defaultMessage: 'What size is your current bra?',
  },
  stage2p1: {
    id: 'size-quiz.stage-2-p1',
    defaultMessage:
      'Did you know we’re a UK brand and we use UK sizes? If you’re unsure, don’t worry! Give us a call on ',
  },
  stage2p1or: {
    id: 'size-quiz.stage-2-p1-or',
    defaultMessage:
      ' or have a virtual fitting with us and one of our friendly fitters can support you.',
  },
  stage3h5: {
    id: 'size-quiz.stage-3-h5',
    defaultMessage:
      'Do you ever notice that the backband of your bra rides up?',
  },
  stage3p1: {
    id: 'size-quiz.stage-3-p1',
    defaultMessage:
      '"If your bra is riding up your back, it means the back band is too big. It should sit horizontally across your body without riding up or digging in. Go down a back size and up a cup size - it’ll make the world of difference!” - Laura, Bra Fitter Leamington shop.',
  },
  stage3p2: {
    id: 'size-quiz.stage-3-p2',
    defaultMessage:
      'It might surprise you but we don’t use tape measures, we fit by eye so we’ll be using the bra you’re currently wearing to work out your size.',
  },
  stage3p2Header: {
    id: 'size-quiz.stage-3-p2-header',
    defaultMessage: 'Did you know?',
  },
  stage4para1: {
    id: 'size-quiz.stage-4-p1',
    defaultMessage:
      'If you lifted your arms above your head, would the underwires (underneath your boobs) lift away from your body at all?',
  },
  stage4para2: {
    id: 'size-quiz.stage-4-p2',
    defaultMessage:
      'If your underwires look like this, they’re lifting away from your body. They should sit flat on your ribcage all the way round to your armpits, lying flat against your chest without digging in, rubbing or poking out.” - Ellen, Bra Fitter Newcastle shop.',
  },
  stage5para1: {
    id: 'size-quiz.stage-5-p1',
    defaultMessage:
      'Place your fingers into the backband of the bra underneath your armpit and pull it away from you as far as you can. How far can you pull the bra out?',
  },
  stage5para2: {
    id: 'size-quiz.stage-5-p2',
    defaultMessage:
      'Did you know you should wear your bra on the loosest hook? This gives you room to tighten the bra when it stretches over time.” - Holly, Bra Fitter Customer Services team',
  },
  stage6para1: {
    id: 'size-quiz.stage-6-p1',
    defaultMessage:
      'Thank you for your answers! We recommend the back size for you to try is…',
  },
  stage6para2: {
    id: 'size-quiz.stage-6-p2',
    defaultMessage:
      'Different size to what you were expecting? Don’t worry! 92% of customers changed size after their first Bravissimo fitting.',
  },
  stage6para3: {
    id: 'size-quiz.stage-6-p3',
    defaultMessage:
      'If you have any questions or need some advice, chat with one of our friendly and experienced fitters over the phone on ',
  },
  stage6para3or: {
    id: 'size-quiz.stage-6-p3-or',
    defaultMessage: ' or via a virtual fitting.​',
  },
  stage7para1: {
    id: 'size-quiz.stage-7-p1',
    defaultMessage:
      'Look down at the wires in the centre-front of your bra, do they sit flat on your breastbone?',
  },
  stage7para2: {
    id: 'size-quiz.stage-7-p2',
    defaultMessage:
      '“If the centre of your bra doesn’t lay flat against your chest, it could be because the back band is too big or because the cups are too small, and your boobs are pushing the centre out.” - Abigail, Bra Fitter Milton Keynes shop​.',
  },
  stage7bpara1: {
    id: 'size-quiz.stage-8-p1',
    defaultMessage: 'How far out are they?',
  },
  stage8para1: {
    id: 'size-quiz.stage-9-p1',
    defaultMessage:
      'Place your fingers on the end of the underwire (close to your armpit) and press the wires against you gently. Does this feel like you are pressing into your boob or onto your ribs?',
  },
  stage8para2: {
    id: 'size-quiz.stage-9-p2',
    defaultMessage:
      '“No one wants their underwire sitting on their breast tissue, it can be pretty uncomfortable! They should sit under your armpit and fully encase your boobs.” - Freya, Bra Fitter Norwich shop.',
  },
  stage9para1: {
    id: 'size-quiz.stage-10-p1',
    defaultMessage:
      'Look at how the cups are fitting you. Can you see any of your boob overflowing over the edge of the cups?',
  },
  stage9para2: {
    id: 'size-quiz.stage-10-p2',
    defaultMessage: 'By how much?',
  },
  stage9para3: {
    id: 'size-quiz.stage-10-p3',
    defaultMessage:
      '“There should be a smooth line where the cups end with no bulging – even in a plunge bra! If your boobs are spilling out then you need a bigger cup size.” - Claire, Bra Fitter, Customer Services team.',
  },
  stage10para1: {
    id: 'size-quiz.stage-11-p1',
    defaultMessage: 'Still looking at the cups, can you see any wrinkling?',
  },
  stage10para2: {
    id: 'size-quiz.stage-11-p2',
    defaultMessage: 'By how much?',
  },
  stage10para3: {
    id: 'size-quiz.stage-11-p3',
    defaultMessage:
      '“If your cups are wrinkling then it’s a sign there’s too much room in the cups. You may also find one cup wrinkles more than another. This is completely normal, so many women have one boob bigger than the other, we recommend fitting to the bigger boob.” - Laura, Customers Services Manager.',
  },
  stage10span1: {
    id: 'size-quiz.stage-11-span1',
    defaultMessage: 'Tip: Pinch the loose fabric',
  },
  stage11h2: {
    id: 'size-quiz.stage11h2',
    defaultMessage: 'We’ve found your size!',
  },
  stage11para1: {
    id: 'size-quiz.stage11para1',
    defaultMessage:
      'We can’t wait for you to discover the difference a well-fitting bra can make! Enter your email and we’ll share all our most-loved styles in your size.',
  },
  stage11submitButton: {
    id: 'size-quiz.stage11submitButton',
    defaultMessage: 'See my size',
  },
  stage11promoCheckbox: {
    id: 'size-quiz.stage11promoCheckbox',
    defaultMessage:
      'Be the first to hear about new collections, sales and expert fitting tips!',
  },
  submitEmail: {
    id: 'size-quiz.submitEmail',
    defaultMessage: 'See my size',
  },
  underwirespara1: {
    id: 'size-quiz.underwires-p1',
    defaultMessage:
      'If your underwires look like this, they’re lifting away from your body. The underwires in your bra should sit on flat on your ribcage (not your boobs!) all the way round to your armpits. The wires between your boobs should lie flat against your chest without digging in, rubbing or poking out.',
  },
  wrinklingpara1: {
    id: 'size-quiz.wrinkling-p1',
    defaultMessage:
      'If your bra cups are wrinkling, this is a sign that there is too much room in the cups',
  },
});
